import React from 'react';
import classNames from 'classnames';
import { isObject } from '../utils/utils';
const Col = (props) => {
    const getColumnSizeClass = (isXs, colWidth, colSize) => {
        if (colSize === '') {
            return isXs ? 'ac-col' : `ac-col-${colWidth}`;
        }
        else if (colSize === 'auto') {
            return isXs ? 'ac-col-auto' : `ac-col-${colWidth}-auto`;
        }
        return isXs ? `ac-col-${colSize}` : `ac-col-${colWidth}-${colSize}`;
    };
    const getColClasses = () => {
        const { attribute } = props;
        const colClasses = [];
        const colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
        colWidths.forEach((colWidth, i) => {
            let columnProp = props[colWidth];
            if (attribute) {
                delete attribute[colWidth];
            }
            if (!columnProp && columnProp !== '') {
                return;
            }
            const isXs = i === 0;
            if (isObject(columnProp)) {
                const colSizeInterfix = isXs ? '-' : `-${colWidth}-`;
                const colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
                colClasses.push(classNames({
                    [colClass]: columnProp.size || columnProp.size === '',
                    [`order${colSizeInterfix}${columnProp.order}`]: columnProp.order || columnProp.order === 0,
                    [`offset${colSizeInterfix}${columnProp.offset}`]: columnProp.offset || columnProp.offset === 0,
                }));
            }
            else {
                const colClass = getColumnSizeClass(isXs, colWidth, columnProp);
                colClasses.push(colClass);
            }
        });
        if (!colClasses.length) {
            colClasses.push('ac-col');
        }
        return colClasses;
    };
    const { className, attribute, children, tag = 'div' } = props;
    const resultClassName = classNames(className, getColClasses());
    if (tag === 'li') {
        return (React.createElement("li", Object.assign({}, attribute, { className: resultClassName }), children));
    }
    else {
        return (React.createElement("div", Object.assign({}, attribute, { className: resultClassName }), children));
    }
};
export { Col };
//# sourceMappingURL=Col.js.map